module.exports = __webpack_public_path__ + "static/ff-landing-image-header-CCAlaurel.48af9cf5.png";